module.exports = __webpack_public_path__ + "img/station_logoRight.521fc83e.png";